module.exports = __webpack_public_path__ + "img/icon_food.9e0e947.svg";